/**
 * @ngdoc controller
 * @name ContactDetailsController
 * @description This controller mainly deals with registration of new
 *              shareholder
 * @requires TokenSvc is the service which is being used to interact with REST
 * @requires $scope for storing information in scope
 * @requires $log mainly used for logging. Used only $log.debug and could be
 *           enabled/disabled based on need.
 * @requires $filter to translate messages from locale file
 */
'use strict';
angular.module('loginModule')
  .controller(
    'ContactDetailsController',
    [
      '$scope',
      'userGroupService',
      '$log',
      '$sessionStorage',
      '$stateParams',
      function(
        $scope,
        userGroupService,
        $log,
        $sessionStorage,
        $stateParams
      ) {
        const userTypeMap = {
          intermediary: 'IN',
          agent: 'AG',
          issuer: 'IS',
          votecollector: 'VC',
          shareholderlogin: 'SH',
          shareholder: 'SH'
        };

        let userType = userTypeMap[$stateParams.userType];
        if (!userType) {
          userType = $sessionStorage.usertype === '' ? 'undefined' : $sessionStorage.usertype;
        }

        $scope.userType = userType;
        userGroupService.getContactDetails($scope.userType)
          .query().$promise.then(function(data) {
            $scope.contactDetails = data;
          }, function(error) {
            $log.debug(error);
          });
      }]);
